export default "__VITE_ASSET__CcH6EMFo__"